import EditorVM from './editor-vm';

export default {
  init: function(node){
    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    var validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
      grouping: { deep: true, observable: true, live: true }
    };

    var enrollment_data = JSON.parse($('#enrollments_json').val());
    ko.applyBindingsWithValidation(new EditorVM(enrollment_data), node, validationOptions);
  }
};
